import React from "react";
import { noLogo } from "src/config/host";

const AuthContainer = ({ children, header, site }) => {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-lg">
      <div className="min-h-[183px] overflow-hidden rounded-lg bg-white shadow-md">
        <div className="bg-headerColor px-4 py-8 sm:px-10">
          <div className="mx-auto h-20 w-auto max-w-[400px] px-3 lg:px-0">
            <div className="inline-block h-full w-full py-0.5">
              {site?.image_logo && (
                <img
                  className="h-full w-full object-contain"
                  src={`${site?.image_logo}?${Date.now()}`}
                  alt="Logo"
                  onError={(e) => (e.target.src = `${noLogo}`)}
                />
              )}
            </div>
          </div>
        </div>
        <div className="space-y-8 px-4 py-8 sm:px-10">
          <div>{header}</div>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthContainer;
